import { AuthGuard } from 'src/app/guards/auth.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthHomeComponent } from './auth-home/auth-home.component';
import { DashboardComponent } from '../dashboard/dashboard/dashboard.component';
import { NotificationViewComponent } from '../notification/notification-view/notification-view.component';
import { DateComponent } from '../basic-data/Date/Date.component';
import { HomePreviewComponent } from '../basic-data/Home-preview/Home-preview.component';




const routes: Routes = [

  { path: 'landind' , component: AuthHomeComponent, children : [
 
    {
      path: 'auth/basic-data', loadChildren: () => import('../basic-data/basic-data.module').then(m => m.BasicDataModule)
    },
    {
      path: 'admin', loadChildren: () => import('../account/account.module').then(m => m.AccountModule)
    },
    {
      path: 'Sas', loadChildren: () => import('../sas/sas.module').then(m => m.SasModule)
    }
    
   
    ,
    { path: '', component:HomePreviewComponent},
    { path: 'notification', children:
    [
      { path: 'notification-view', component: NotificationViewComponent } ,
      { path: '', component: NotificationViewComponent }
  
    
    ] }

  ]},
  { path: '' , component: AuthHomeComponent, children : [
 
    {
      path: 'auth/basic-data', loadChildren: () => import('../basic-data/basic-data.module').then(m => m.BasicDataModule)
    },
    {
      path: 'admin', loadChildren: () => import('../account/account.module').then(m => m.AccountModule)
    },
    {
      path: 'Sas', loadChildren: () => import('../sas/sas.module').then(m => m.SasModule)
    }
    
   
    ,
    { path: '', component:HomePreviewComponent},
    { path: 'notification', children:
    [
      { path: 'notification-view', component: NotificationViewComponent } ,
      { path: '', component: NotificationViewComponent }
  
    
    ] }

  ]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthHomeRoutingModule { }
